<script setup lang="ts">
import { XSquare } from 'lucide-vue-next';

const { t } = useI18n();
const companyStore = useCompanyStore();

const closedWarning = ref(false);

const isLimitReached = computed(() => {
  return companyStore.company.numActiveChats > companyStore.company.pricingPlan?.monthlyChatsLimit;
});

const freeTrialMessage = computed(() => {
  return t('modals.chatLimitWarning.freeTrialMessage', { limit: companyStore.company.pricingPlan?.monthlyChatsLimit });
});

const paidPlanMessage = computed(() => {
  return t('modals.chatLimitWarning.paidPlanMessage', {
    cost: companyStore.company.pricingPlan?.extraChatsCost,
    limit: companyStore.company.pricingPlan?.monthlyChatsLimit,
  });
});
</script>

<template>
  <Transition name="fade">
    <div
      v-if="isLimitReached && !closedWarning"
      class="fixed bottom-6 left-1/2 min-w-sm transform border border-red-400 rounded-lg bg-red-100 p-4 text-yellow-900 shadow-md -translate-x-1/2"
    >
      <div class="flex gap-4">
        <p class="self-center text-sm">
          {{ companyStore.company.pricingPlan?.name === "Trial" ? freeTrialMessage : paidPlanMessage }}
        </p>
        <SBButton variant="ghost" :lucide-icon="XSquare" @click="closedWarning = true" />
      </div>
    </div>
  </Transition>
</template>
